module.exports = __webpack_public_path__ + "static/img/Sargeant.aa4f1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sargeant.jpg
// module id = feLg
// module chunks = 1